import * as z from "zod/v4";

export const publishAutomationGroup = {
  name: "publishAutomationGroup" as const,
  input: z.object({ ruleId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
